import Axios from 'axios';
Axios.interceptors.request.use(config => {
    config.headers["Csrf-Token"] = 'nocheck';
    return config;
});
function resolveHost(env) {
    switch (env) {
        case "dev":
            return "https://dev.firstpay.jp";
        case "prod":
            return "https://www.firstpay.jp";
        case "local":
            return "http://192.168.1.31:9001";
        default:
            return "";
    }
}
export var AuctionAPI;
(function (AuctionAPI) {
    function get(uuid, env) {
        return Axios.get("/api/auction/single", {
            params: {
                id: uuid
            },
            baseURL: resolveHost(env)
        });
    }
    AuctionAPI.get = get;
    function sendmail(mailParams, env) {
        return Axios.post("/api/auction/sendmail", { ...mailParams }, { baseURL: resolveHost(env) });
    }
    AuctionAPI.sendmail = sendmail;
    function resolveFrontEndUrl(uuid, env) {
        return resolveHost(env) + `/auction/${uuid}`;
    }
    AuctionAPI.resolveFrontEndUrl = resolveFrontEndUrl;
})(AuctionAPI || (AuctionAPI = {}));
